<template>
  <div>
    <v-img
      :src="require('@/assets/images/cities/bali.jpg')"
      height="100vh"
      gradient="to top, rgba(3, 169, 244, 0.58) 10%, transparent"
    >
      <v-container
        fluid
        fill-height
        class="flex-column"
      >
        <v-row style="width:100%;">
          <v-col />

          <v-col>
            <div
              class="display-1 white--text text-center"
            >
              vjago
            </div>
          </v-col>

          <v-col class="text-right">
            <v-btn
              v-if="$currentUser"
              depressed
              color="accent"
              :to="{ name: 'trips' }"
            >
              My Trips
            </v-btn>

            <dialog-login v-else />
          </v-col>
        </v-row>

        <v-row class="flex-grow-0">
          <v-col>
            <div class="text-center pb-5 white--text">
              <p class="display-4">
                ⛩️
              </p>

              <p class="display-3">
                Ready for your next trip?
              </p>
              <p class="display-1">
                Plan it with Vjago and share it with your travel companions
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-img>

    <v-container fluid>
      <v-row>
        <v-col class="pa-12">
          <h2 class="display-1">
            Vjago is a simple app for planning trips
          </h2>

          <p class="headline mt-4 ml-4">
            Keep track of 💰 costs, 🏠 locations, 🛩️ itinerary
            and more
          </p>

          <p class="headline mt-4 ml-4">
            Share the trips with your 👩‍🦰 friends and plan
            them together 🤝
          </p>

          <p class="headline mt-4 ml-4">
            All your trips 🌍 in one place and forget none!
          </p>

          <v-card
            class="primary my-12"
            flat
            tile
          >
            <v-card-text class="pb-0">
              <p class="display-1 my-4 text-center white--text">
                Get started now and for free!
              </p>

              <div
                class="text-center"
                style="transform: translateY(50%)"
              >
                <dialog-login />
              </div>
            </v-card-text>
          </v-card>

          <h2 class="display-1 d-none d-sm-block">
            Vjago works great 🤟 on mobile 📲
          </h2>

          <p class="headline mt-4 ml-4 d-none d-sm-block">
            Visit this website from your smartphone and
            a popup will request you to Add to the
            Home Screen, so you can use Vjago as a normal app
            but without installing it!
          </p>
        </v-col>

        <v-col
          class="pa-sm-12 pa-0"
        >
          <div
            class="primary pt-12 px-12"
            :style="`box-shadow: -6px 6px 0 #f5f5f5, -16px 16px 0px ${$vuetify.theme.currentTheme.accent};`"
          >
            <div class="chat">
              <div class="chat__header elevation-2 pa-3">
                <div class="display-1 mr-2">
                  🏄
                </div>

                <div>
                  <strong>Summer trip!</strong>
                  <div><em>Luca, Luigi, +3 more</em></div>
                </div>
              </div>

              <div class="chat__messages">
                <v-card
                  v-for="(msg,i) in messages"
                  :key="`msg-${i}`"
                  class="chat__message pa-2"
                >
                  {{ msg }}
                </v-card>

                <v-card
                  class="chat__vjago accent white--text display-3 pa-2 ma-2 text-center"
                >
                  Use Vjago!
                </v-card>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import anime from 'animejs/lib/anime.es.js'

import DialogLogin from '@/components/DialogLogin'

export default {
  components: {
    DialogLogin
  },
  data () {
    return {
      intersectionObserver: null,
      messages: [
        'So where we go?? 🤔',
        'Somewhere with cool 🏖️... south France?',
        'Mmm I vote Italy 🇮🇹!',
        'OK check tickets price',
        'Hey this month I\'m low, keep it below €200',
        'Check also for Germany 🍺 so we stay fresh',
        'F*ck they don\'t have the seaside!!',
        'Ahh too many things, I\'ll share an 📜 excel',
        'N💣💣💣💣💣💣, don\'t dare!'
      ]
    }
  },
  mounted () {
    const timeline = anime.timeline({
      duration: 300,
      loop: true,
      endDelay: 3000
    })

    timeline.add({
      targets: '.chat__message',
      translateX: [ '-100%', '0%' ],
      opacity: [ 0, 1 ],
      delay: (el, i) => i * 1000
    })

    timeline.add({
      targets: '.chat__vjago',
      scale: [ 0, 1 ],
      rotateZ: [ 0, '-45deg' ],
      duration: 1000,
      easing: 'easeOutElastic',
      opacity: [ 0, 0.85 ]
    })

    const scrollable = document.querySelector('.chat__messages')

    timeline.add({
      targets: scrollable,
      scrollTop: [ 0, scrollable.scrollHeight - scrollable.offsetHeight ],
      duration: this.messages.length * 1000,
      easing: 'linear'
    }, 0)

    // this.intersectionObserver = new IntersectionObserver((entries) => {
    //   timeline.restart()
    // }, { threshold: 0.8 })

    // this.intersectionObserver.observe(document.querySelector('.chat'))
  },
  beforeDestroy () {
    // this.intersectionObserver.unobserve(document.querySelector('.chat'))
  }
}
</script>

<style lang="scss">
.chat {
  background: linear-gradient(to bottom right, #eaeaea, #6293bb);
  border: 2px solid black;
  border-bottom-width: 0;
  border-radius: 30px 30px 0 0;
  margin: 0 auto;
  max-width: 400px;
  overflow: hidden;
  position: relative;

  &__header {
    position: relative;
    display: flex;
    justify-content: center;
    align-content: center;
    background: white;
    z-index: 1;
  }

  &__messages {
    max-height: 80vh;
    overflow-y: auto;
  }

  &__message {
    max-width: 80%;
    margin: 1em;

    &:nth-child(odd) {
      border-top-right-radius: 0px;
      margin-left: auto;
    }

    &:nth-child(even) {
      border-top-left-radius: 0px;
      margin-right: auto;
    }
  }

  &__vjago {
    transform-origin: top left;
    position: absolute;
    top: 50%;
  }
}
</style>
